import React from 'react';
import { Col, Row } from 'react-bootstrap';

const Video = () => {
    return (
        <div className='py-5 bg-light'>
            <div className="container">
                <h2 className='text-center pb-4'>আমের ভিডিও</h2>
                <div>
                    <Row xs={1} md={2} lg={3} className="g-4">
                        <Col>
                            <iframe className='w-100' height="315" src="https://www.youtube.com/embed/SSLctWiyPr0" title="YouTube video player" frameborder="0" allow="accelerometer; autoplay; clipboard-write; encrypted-media; gyroscope; picture-in-picture" allowfullscreen></iframe>
                        </Col>
                        <Col>
                            <iframe className='w-100' height="315" src="https://www.youtube.com/embed/WRh36vkTu2Q" title="YouTube video player" frameborder="0" allow="accelerometer; autoplay; clipboard-write; encrypted-media; gyroscope; picture-in-picture" allowfullscreen></iframe>
                        </Col>
                        <Col>
                        <iframe className='w-100' height="315" src="https://www.youtube.com/embed/Gl-rWHJPtec" title="YouTube video player" frameborder="0" allow="accelerometer; autoplay; clipboard-write; encrypted-media; gyroscope; picture-in-picture" allowfullscreen></iframe>
                        </Col>
                    </Row>
                </div>
            </div>
        </div>
    );
};

export default Video;